<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">年检预约</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!-- banner背景色 -->
    <div class="appointment-banner"></div>
    <!-- 店铺信息 开始 -->
    <div class="appointment-shopmesg">
      <div class="appointment-shoptop">
        <div class="appointment-shopimgmesg">
          <img class="appointment-img" :src="storeDesc.thumb_url" />
          <div class="appointment-mesgbox">
            <div class="appointment-shopname">{{ storeDesc.name }}</div>
            <div class="appointment-type">小型车 大型车 能源型车</div>
          </div>
        </div>
        <div class="appointment-telphone">
          <div class="appointment-timebox">
            <img class="appointment-timeicon" src="/static/newprojecticon/shijianicon.png" />
            <div class="appointment-timetext">营业时间：</div>
            <div class="appointment-time">{{ storeDesc.business_time }}</div>
          </div>
          <div class="appointment-timebox">
            <img class="appointment-timeicon" src="/static/newprojecticon/dianhuaicon.png" />
            <div class="appointment-timetext">联系电话：</div>
            <div class="appointment-tel"><a class="contLinephone" :href="'tel:' + storeDesc.store_tel">{{ storeDesc.store_tel }}</a></div>
          </div>
        </div>
      </div>
      <div class="appointment-shopbot" @click="getMyLocation()">
        <div class="appointment-addressbox">
          <img class="appointment-addicon" src="/static/newprojecticon/juliicon.png" />
          <div class="appointment-address">地址：{{ storeDesc.province + storeDesc.city + storeDesc.address }}</div>
        </div>
        <img class="appointment-toaddress" src="/static/newicon/more.png" />
      </div>
    </div>
    <!-- 店铺信息 结束 -->
    <!-- 基本信息 开始 -->
    <div class="appointment-inputmesg">
      <div class="appointment-inputmesgtitle">
        <img class="appointment-inputmesgicon" src="/static/newprojecticon/title.png" />
        <div class="appointment-inputmesgtext">基本信息</div>
      </div>
      <div class="appointment-choosecar" @click="toCarLicenseList()">
        <img class="appointment-mesgicon" src="/static/chepai.png" />
        <div class="appointment-choosebox">
          <div :class="licenseItem.car_no?'appointment-carnum1':'appointment-carnum'">{{licenseItem.car_no? licenseItem.car_no : '请选择车辆'}}</div>
          <img class="appointment-checkmore" src="/static/newicon/more.png" />
        </div>
      </div>
      <div class="appointment-mesginput">
        <img class="appointment-mesgicon" src="/static/name.png" />
        <input class="appointment-name" placeholder="请输入联系人姓名" v-model="name" />
      </div>
      <div class="appointment-mesginput">
        <img class="appointment-mesgicon" src="/static/dianhuaicon.png" />
        <input class="appointment-name" placeholder="请输入联系人电话" v-model="phone" />
      </div>
     <!-- <div class="appointment-mesginput1">
        <div class="appointment-addressbox">
          <img class="appointment-mesgicon" src="/static/dizhiicon.png" />
          <input class="appointment-name" placeholder="请输入详细地址" v-model="address" />
        </div>
        <img class="appointment-checkmore" src="/static/dingwei.png" @click="toChooseLocation()" />
      </div> -->
    </div>
    <!-- 基本信息 结束 -->
    <!-- 预约时间 开始 -->
    <div class="appointment-yuyuetimebox">
      <div class="appointment-inputmesgtitle">
        <img class="appointment-inputmesgicon" src="/static/newprojecticon/title.png" />
        <div class="appointment-inputmesgtext">预约时间</div>
      </div>
      <div class="appointment-yuyuedatebox">
        <img class="appointment-dateicon" src="/static/qianyitian.png" @click="previousDate()" />
        <div class="appointment-datelist">
          <div class="appointment-datebox" v-for="(item,index) in datebox" @click="checkdate(index)">
            <div :class="item.ischeckdate? 'appointment-yuyuedate':'appointment-yuyuezhou'">周{{item.day}}</div>
            <div :class="item.ischeckdate? 'appointment-yuyuedate':'appointment-yuyuezhou'">{{item.date}}</div>
          </div>
        </div>
        <img class="appointment-dateicon1" src="/static/houyitian.png" @click="nextDate()" />
      </div>
      <div class="appointment-yuyuetimelist">
        <div :class="item.isOptional? (item.ischeck? 'appointment-yuyuetimeboxb1' : 'appointment-yuyuetimeboxb2') : 'appointment-yuyuetimeboxb'"
          v-for="(item,index) in times" @click="item.isOptional? choosetime(index) : ''">
          <div :class="item.isOptional? (item.ischeck? 'appointment-yuyuetime1' : 'appointment-yuyuetime2') : 'appointment-yuyuetime'">{{item.time}}</div>
          <div :class="item.isOptional?
          (item.ischeck? 'appointment-yuyuetimetext' : 'appointment-yuyuetimetext2')
          : 'appointment-yuyuetimetext'">{{item.isOptional? '可预约' : '已约满'}}</div>
          <img v-if="item.isOptional && item.ischeck" class="appointment-yuyuetimeboxcheck" src="/static/newprojecticon/chongzhicheck.png" />
        </div>
      </div>
    </div>
    <!-- 预约时间 结束 -->
    <!-- 确认预约 开始 -->
    <div class="appointment-yuyuebotton" @click="toYearlyConfirm()">确认预约</div>
    <!-- 确认预约 结束 -->
    <div class="inspection-material">
      <div class="material-title">
        <img class="material-titleicon" src="/static/newprojecticon/title.png" />
        <div class="material-titlename">年检所需材料</div>
      </div>
      <div class="material-box">
        <div class="material-mesg">
          <img class="material-mesgicon" src="/static/xingshizheng.png" />
          <div class="material-mesgtext">行驶证</div>
          <div class="material-mesgtexttip">原件</div>
        </div>
        <div class="material-mesg">
          <img class="material-mesgicon" src="/static/jiaoqiangxian.png" />
          <div class="material-mesgtext">交强险报单</div>
          <div class="material-mesgtexttip">有效期内</div>
        </div>
        <div class="material-mesg">
          <img class="material-mesgicon" src="/static/shenfenzheng.png" />
          <div class="material-mesgtext">办理人身份证</div>
          <div class="material-mesgtexttip">原件</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import httper from "../../api/http";
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        name: "", //联系人
        phone: "", //联系人电话
        address: "", //地址
        address1: "",
        licenseItem: "", //车辆信息
        day: "",
        datemonth: "",
        datedate: "",
        datebox: [], //显示日期列表
        times: [{
          starttime: 0,
          endtime: 12,
          time: "8:00-9:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 0,
          endtime: 12,
          time: "9:00-10:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 0,
          endtime: 12,
          time: "10:00-11:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 0,
          endtime: 12,
          time: "11:00-12:00",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 12,
          endtime: 24,
          time: "13:30-14:30",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 12,
          endtime: 24,
          time: "14:30-15:30",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 12,
          endtime: 24,
          time: "15:30-16:30",
          ischeck: false,
          isOptional: false
        }, {
          starttime: 12,
          endtime: 24,
          time: "16:30-17:30",
          ischeck: false,
          isOptional: false
        }], //时间段列表
        datebox1: [], //所有日期
        nowDate: '', //当前日期
        latitude: "",
        longitude: "",
        storeDesc: {},
        store_id: "", //店铺列表获取的店铺id
        checkDate: "", //所选日期
        checkTime: "", //所选时间
        productId: "",
        inspectiondetail: "",
        serviceDetail: "",
        product_name: "",
        product_type: ""
      }

    },
    created() {
      this.getwechat({
        url: location.href.split('#')[0]
      })
      if (this.$route.query.store_id) {
        this.store_id = this.$route.query.store_id
      } else if (this.$route.params.store_id) {
        this.store_id = this.$route.params.store_id
      } else {
        this.store_id = ""
      }

      if (this.$route.query.product_name) {
        this.product_name = this.$route.query.product_name;
      } else {
        this.product_name = "";
      }
      //上页面获取商品服务类型
      if (this.$route.query.product_type) {
        this.product_type = this.$route.query.product_type;
      } else {
        this.product_type = "";
      }
      if (this.$route.query.product_id) {
        this.productId = this.$route.query.product_id
      }
      let getstoredata = {
        id: this.store_id,
      }

      this.request("getStore", getstoredata);
      // if (this.$route.query.licenseItem) {
      //   this.licenseItem = JSON.parse(this.$route.query.licenseItem)
      //   this.name = this.licenseItem.owner
      // }

      if (this.$route.query.licenseItem) {
        this.licenseItem = JSON.parse(this.$route.query.licenseItem)
        this.name = this.licenseItem.owner

      } else {
        this.licenseItem = "";
      }
      // if (this.$route.query.name) {
      //   this.name = this.$route.query.name;
      // } else {
      //   this.name = "";
      // }
      if (localStorage.getItem('userinfo')) {
        this.phone = JSON.parse(localStorage.getItem('userinfo')).mobile;
      }else{
        Dialog.confirm({
            title: '提示',
            message: '请先绑定手机',
          })
          .then(() => {
            that.$router.push({
              path: "/changePhoneNum"
            })
          })
          .catch(() => {
            return false;
          });
      }
      if (this.$route.query.phone) {
        this.phone = this.$route.query.phone;
      }
      if (this.$route.query.address) {
        this.address1 = this.$route.query.address;
        this.address = this.address1.pname + this.address1.cityname + this.address1.address + this.address1.name
      } else {
        this.address1 = "";
      }
      if (this.$route.query.storeDesc) {
        this.storeDesc = this.$route.query.storeDesc;
        console.log("storeDesc", this.storeDesc)
      } else {
        this.storeDesc = "";
      }
      this.getChoosetime()
      this.getChoosedate()
      this.request("getDetail", {
        id: this.productId
      })
      this.request("getServiceDetail", {
        name: this.product_name,
        store_id: this.store_id
      })
    },
    mounted() {

    },
    methods: {
      pageReturn() {
        this.$router.push({
          path: "/yearInspectionType"
        })
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      //获取微信配置信息接口
      getwechat(requestData = {}) {
        httper.get("wechat/wechat/sign-package", requestData, res => {
          console.log(res);
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: ["openLocation"] // 必填，需要使用的JS接口列表
          });
        });
      },
      //获取定位
      getMyLocation() {
        if (this.storeDesc && this.latitude) {
          console.log("纬度", Number(this.latitude)) //接口获取店铺信息获得经纬度
          console.log("经度", Number(this.longitude))
          // wx.ready(() => {
          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
          wx.openLocation({
            latitude: Number(this.latitude), // 纬度，浮点数，范围为90 ~ -90
            longitude: Number(this.longitude), // 经度，浮点数，范围为180 ~ -180。
            name: this.storeDesc.name,
            address: this.storeDesc.address,
            scale: 16
          });
          // });
        }
      },
      //选择时间段
      choosetime(e) {
        var timesd = this.times
        timesd.map(function(item, index) {
          item.ischeck = index == e
        })
        this.times = timesd
        this.checkTime = this.times[e].time
      },
      //获取时间段
      getChoosetime() {
        let datestart = new Date().getTime()
        var hourse = new Date(datestart).getHours()

        let times1 = this.times

        // console.log("this.nowDate",this.nowDate)
        // console.log("datedate",datedate)
        times1.map(function(item, i) {
          if (item.starttime <= hourse) {
            item.isOptional = false
          } else {
            item.isOptional = true;
          }
        })
        this.times = times1
      },
      //获取日期段
      getChoosedate() {
        // let datestart = new Date().getTime()
        // this.datemonth = new Date(datestart).getMonth() + 1;
        // var datedate = new Date(datestart).getDate();
        // let datestartday = new Date(datestart).getDay();
        // var cn = ["日", "一", "二", "三", "四", "五", "六"]
        // new Date().setDate(new Date().getDate())
        let datetimes = []
        for (var i = 0; i < 16; i++) {
          var datetime = new Date().setTime(new Date().getTime() + (i * 24 * 60 * 60 * 1000))
          datetimes.push(datetime)
        }

        let datebox1 = []
        for (var j = 0; j < 16; j++) {
          let datemonth1 = new Date(datetimes[j]).getMonth() + 1;
          let datedate1 = new Date(datetimes[j]).getDate();
          let datestartday1 = new Date(datetimes[j]).getDay();
          let dateYear = new Date(datetimes[j]).getYear()
          var cn = ["日", "一", "二", "三", "四", "五", "六"]
          datebox1.push({
            day: cn[datestartday1],
            date: datemonth1 + "." + datedate1,
            nowdate: datedate1,
            ischeckdate: false,
            dateYear:dateYear,
            datemonth:datemonth1
          })
        }

        this.datebox1 = datebox1
        this.datebox1[0].ischeckdate = true
        this.checkDate = this.datebox1[0].date
        // for(var t = 0; t < 5; t++){
        //   this.datebox.push(this.datebox1[t])
        // }
        this.datebox = [datebox1[0], datebox1[1], datebox1[2], datebox1[3], datebox1[4]]
      },
      //下一组日期
      nextDate() {
        let datebox11 = []
        for (var t = 5; t < 10; t++) {
          datebox11.push(this.datebox1[t])
        }
        this.datebox = datebox11
      },
      //返回上一组日期
      previousDate() {
        let datebox11 = []
        for (var t = 0; t < 5; t++) {
          datebox11.push(this.datebox1[t])
        }
        this.datebox = datebox11
      },
      //选择日期
      checkdate(e) {
        let datebox1 = this.datebox
        let datestart = new Date().getTime()
        var datedate = new Date(datestart).getDate();
        let times1 = this.times

        datebox1.map(function(item, i) {
          item.ischeckdate = i == e
        })
        this.nowDate = this.datebox[e].nowdate
        console.log("this.datebox[e].date", this.datebox[e])
        if (this.nowDate == datedate) {
          this.getChoosetime()
        } else {
          times1.map(function(item, i) {
            item.isOptional = true;
          })
          this.times = times1
        }
        this.datebox = datebox1
        this.checkDate = this.datebox[e].date
      },
      //选择车牌
      toCarLicenseList() {
        // console.log("this.storeDesc选择车牌",this.storeDesc)
        let isSelectLicense = true
        this.$router.push({
          path: "/CarLicenseList",
          query: {
            product_id: this.productId,
            isSelectLicense: isSelectLicense,
            name: this.name, //联系人
            phone: this.phone, //联系人电话
            address: this.address1, //地址
            date: this.checkDate,
            time: this.checkTime,
            items: "appointmentYearInsp",
            store_id: this.store_id,
            product_name: this.product_name,
            product_type: this.product_type
          }
        })
      },
      //选择地址
      toChooseLocation() {
        //console.log("this.storeDesc选择地址",this.storeDesc)
        this.$router.push({
          path: "/chooseLocation",
          query: {
            product_id: this.productId,
            name: this.name, //联系人
            phone: this.phone, //联系人电话
            licenseItem: this.licenseItem,
            date: this.checkDate,
            time: this.checkTime,
            isAppointment: true,
            store_id: this.store_id,
            product_name: this.product_name,
            product_type: this.product_type
          }
        })
      },
      //确认预约-跳转确认页
      toYearlyConfirm() {
        let that = this
        let yearConfirmMesg = {}
        if (!that.licenseItem.car_no) {
          this.$toast({
            message: '请选择本服务车辆'
          })
          return
        }
        if (!that.name) {
          this.$toast({
            message: '请输入联系人姓名',
          });
          return
        }
        if (!that.phone) {
          this.$toast({
            message: '请输入联系人电话',
          });
          return
        }
        // if (!that.address) {
        //   this.$toast({
        //     message: '请输入详细地址',
        //   });
        //   return
        // }
        if (!that.checkDate) {
          this.$toast({
            message: '请选择预约日期',
          });
          return
        }
        if (!that.checkTime) {
          this.$toast({
            message: '请选择预约时间',
          });
          return
        }
        yearConfirmMesg = {
          car_no: that.licenseItem.car_no,
          name: that.name,
          phone: that.phone,
         // address: that.address,
          driving_license_id: that.licenseItem.id,
          product_id: that.productId,
          price: that.serviceDetail.price,
          book_date: that.checkDate,
          book_time: that.checkTime,
          service_price: that.storeDesc.cityConfig.service_fee,
          store_id: this.store_id,
          product_item_id: that.serviceDetail.id,
          product_type: this.product_type,
          city:this.storeDesc.city,
          storeName:this.storeDesc.name,
          serviceName:that.inspectiondetail.name,
          Drivingtype:false
        }
        this.$router.push({
          path: "/yearlyconfirm",
          query: {
            yearConfirmMesg: JSON.stringify(yearConfirmMesg)
          }
        })
      },
      // 调用接口
      request(type = "", requestData = {}) {
        let that = this;
        let data = {};
        switch (type) {
          // 获取店铺详情
          case "getStore":
            httper.get(
              "store/store-detail",
              requestData,
              res => {
                that.storeDesc = res.data;
                that.latitude = res.data.latitude
                that.longitude = res.data.longitude
                console.log("latitude纬度", that.latitude)
                console.log("longitude经度", that.longitude)
              },
              false
            );
            break;
            //获取服务详情
          case 'getServiceDetail':
            httper.get('/store/service-detail', requestData, res => {
              console.log('套餐详情', res)
              that.serviceDetail = res.data
            }, false)
            break
            //获取商品详情
          case 'getDetail':
            httper.get('/product/detail', requestData, res => {
              if (res.code == 0) {
                this.inspectiondetail = res.data
                console.log("this.inspectiondetail", this.inspectiondetail)
              } else {
                this.$toast({
                  message: res.message || '系统异常'
                })
              }
            })
            break
        }
      },
    }
  }
</script>

<style>
  .appointment-banner {
    width: 100%;
    height: 184px;
    background: #FD8C00;
  }

  .appointment-shopmesg {
    width: calc(100% - 20px);
    margin: 0 10px;
    position: relative;
    top: -130px;
    background-color: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
    /* height: 100%; */
  }

  .appointment-shoptop {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    border-bottom: 1px dashed #BFBFBF;
  }

  .appointment-shopimgmesg {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .appointment-img {
    width: 138px;
    height: 77px;
    border-radius: 4px;
    margin-right: 13px;
  }

  .appointment-mesgbox {}

  .appointment-shopname {
    font-size: 16px;
  }

  .appointment-type {
    font-size: 12px;
    color: #FD8C00;
  }

  .appointment-telphone {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .appointment-timebox {
    display: flex;
    align-items: center;
  }

  .appointment-timeicon {
    width: 15px;
    height: 15px;
    /*   margin-right: 5px; */
  }

  .appointment-timetext {
    font-size: 12px;
    color: #666666;
  }

  .appointment-time {
    font-size: 12px;
    color: #666666;
  }

  .appointment-tel {
    font-size: 12px;
    color: #FD8C00;
  }

  .appointment-shopbot {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* flex-wrap: wrap; */
  }

  .appointment-addressbox {
    display: flex;
    align-items: center;
  }

  .appointment-addicon {
    width: 15px;
    height: 15px;
    margin-right: 5px;
  }

  .appointment-address {
    font-size: 12px;
    color: #666666;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  .appointment-toaddress {
    width: 15px;
    height: 15px;

  }

  /* 基本信息 开始 */
  .appointment-inputmesg {
    width: calc(100% - 20px);
    margin: -110px 10px 20px 10px;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);

  }

  .appointment-inputmesgtitle {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .appointment-inputmesgicon {
    width: 4px;
    height: 23px;
    margin-right: 10px;
  }

  .appointment-inputmesgtext {
    font-size: 12px;
    /*    margin-bottom: 20px; */
  }

  .appointment-choosecar {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    height: 30px;
  }

  .appointment-mesgicon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  .appointment-choosebox {
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .appointment-carnum {
    font-size: 16px;
    color: #BBBBBB;
  }

  .appointment-carnum1 {
    font-size: 16px;
  }

  .appointment-checkmore {
    width: 15px;
    height: 15px;
  }

  .appointment-name {
    font-size: 16px;
    text-align: start;
    height: 30px;
    width: 280px;
  }

  .appointment-mesginput {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    height: 30px;
  }

  .appointment-mesginput1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    height: 30px;
  }

  input {
    border: none;
  }

  input::-webkit-input-placeholder {
    font-size: 16px;
    color: #BBBBBB;
    text-align: start;
  }

  /* 基本信息 结束 */
  .appointment-yuyuetimebox {
    width: calc(100% - 20px);
    margin: 0 10px;
    margin-bottom: 20px;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
  }

  .appointment-yuyuedatebox {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .appointment-dateicon {
    width: 8%;
    height: 25px;
    margin-right: 10px;
  }

  .appointment-datelist {
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .appointment-datebox {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 0 10px;
  }

  .appointment-yuyuezhou {
    font-size: 12px;
    color: #666666;
  }

  .appointment-yuyuedate {
    font-size: 12px;
    color: #FD8C00;
  }

  .appointment-dateicon1 {
    width: 8%;
    height: 25px;
    margin-left: 10px;
  }

  .appointment-yuyuetimelist {
    width: 100%;
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    flex-wrap: wrap;
  }

  .appointment-yuyuetimeboxb {
    width: 25%;
    border: 1px solid #BCBCBC;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #BCBCBC;
    font-size: 14px;
    /* margin-bottom: 10px; */
    margin: 0 10px 10px 15px;
  }

  .appointment-yuyuetime {}

  .appointment-yuyuetimetext {}

  .appointment-yuyuetimeboxb1 {
    width: 25%;
    /* width: 92px;
    height: 46px; */


background: rgba(253, 140, 0, 0.1);
    border: 1px solid #FD8C00;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #FD8C00;
    font-size: 14px;
    position: relative;
    margin: 0 10px 10px 15px;
  }

  .appointment-yuyuetimeboxcheck {
    width: 21px;
    height: 21px;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .appointment-yuyuetime1 {}

  .appointment-yuyuetimetext1 {}

  .appointment-yuyuetimeboxb2 {
    width: 25%;
    border: 1px solid #FD8C00;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #FD8C00;
    font-size: 14px;
    margin: 0 10px 10px 15px;
  }

  .appointment-yuyuetime2 {}

  .appointment-yuyuetimetext2 {}

  .appointment-yuyuebotton {
    width: calc(100% - 20px);
    margin: 20px 10px 0 10px;
    height: 46px;
    /*  background: linear-gradient(90deg, #E96E56 0%, #E2523E 100%);
    box-shadow: 1px 4px 6px 2px rgba(234, 110, 86, 0.3); */

    background: #FD8C00;
    box-shadow: 0 4px 5px 2px rgba(253, 140, 0, 0.3);
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    font-size: 14px;
    position: fixed;
    bottom: 20px;
  }

  .inspection-material {
    width: calc(100% - 20px);
    margin: 0 10px 80px;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 4px 5px 2px rgba(187, 187, 187, 0.3);
  }

  .material-title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .material-titleicon {
    width: 4px;
    height: 23px;
    margin-right: 10px;
  }

  .material-titlename {
    font-size: 12px;
  }

  .material-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .material-mesg {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* margin-right: 20px; */
  }

  .material-mesgicon {
    width: 50px;
    height: 50px;
    background: rgba(255, 247, 215, 1);
    border-radius: 25px;
    margin-bottom: 10px;
  }

  .material-mesgtext {
    font-size: 12px;
  }

  .material-mesgtexttip {
    font-size: 10px;
    color: #666666;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/appointmentYearInsp.vue